// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field[data-v-113b28ef]{padding:.5rem 1rem;width:100%}.media[data-v-113b28ef]{border:1px solid #d3d3d3;border-bottom:none;padding:.5rem}.media[data-v-113b28ef]:last-child{border-bottom:1px solid #d3d3d3}.icon[data-v-113b28ef]{margin-top:.15rem;margin-left:.5rem}.email-fields[data-v-113b28ef]{margin-top:.5rem;padding:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
